import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * The single chip style used for every carrier capability on the carriers
 * settings page. Deliberately uniform — a capability chip must never compete
 * for attention with its neighbours. Only the restricted-items footer (amber)
 * is allowed to stand out, because it is a warning rather than a capability.
 *
 * Design tokens (light mode): border #E4E4E7, bg #FAFAFA, radius 9px,
 * 13px/500 #3F3F46 text, 14px icon stroked #71717A. The sd-* tokens below
 * resolve to exactly those values and additionally survive dark mode.
 */
export const CHIP_CLASS =
  'inline-flex items-center gap-1.5 rounded-[9px] border border-sd-border ' +
  'bg-sd-muted px-[11px] py-1.5 text-[13px] font-medium text-sd-foreground';

interface CarrierFeatureChipProps {
  icon: LucideIcon;
  label: string;
  className?: string;
}

export function CarrierFeatureChip({ icon: Icon, label, className }: CarrierFeatureChipProps) {
  return (
    <span className={cn(CHIP_CLASS, className)}>
      <Icon className='h-3.5 w-3.5 shrink-0 text-sd-muted-foreground' strokeWidth={2} />
      {label}
    </span>
  );
}
